import { render, staticRenderFns } from "./select-shop-modal.vue?vue&type=template&id=67b10363&scoped=true&"
import script from "./select-shop-modal.vue?vue&type=script&lang=js&"
export * from "./select-shop-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b10363",
  null
  
)

export default component.exports